import { FC, useEffect, useState } from 'react';

import { useGetStartedContext } from '../../../Shared/GetStarted/GetStarted.context';

import Code from '../../../Shared/Code';
import ContentGenerator from '../../../Shared/ContentGenerator';
import Modal from '../../../Shared/Modal';

import { Content } from '../../../../types/tour';
import { useVideoContext } from '../../VideoController/VideoController.context';

const codeSample = () => `
const call = useCall();

const { useCallCallingState, useParticipants } = useCallStateHooks();
const callingState = useCallCallingState();
const localParticipant = useLocalParticipant();
`;

export type Props = {
  content: Content;
  setComplete: () => void;
  goNext: () => void;
};

export const Step6: FC<Props> = ({ setComplete, content }) => {
  const [showModal, setShowModal] = useState(false);

  const { state } = useVideoContext();
  const { state: getStartedState } = useGetStartedContext();
  const completed = getStartedState.steps[getStartedState.current].completed;

  const run = async () => {
    setComplete();
  };

  useEffect(() => {
    if (completed) {
      setShowModal(true);
    }
  }, [completed]);

  return (
    <ContentGenerator
      content={content}
      code={
        <Code
          language="jsx"
          footer={{
            label: 'Run Code',
            disabled: completed,
            run,
          }}
        >
          {codeSample()}
        </Code>
      }
    >
      {showModal && (
        <Modal
          title="Observing the Call State"
          onClose={() => setShowModal(false)}
        >
          {JSON.stringify(state?.callState, null, 2)}
        </Modal>
      )}
    </ContentGenerator>
  );
};
